var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('footer', {
    class: ['footer', _vm._isMobile() ? 'mobile' : '']
  }, [_c('a-row', {
    staticClass: "footer1",
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('a-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 4,
      "lg": 4,
      "xl": 4
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.tenantInfo && _vm.tenantInfo.logo ? _vm.tenantInfo.logo : '/img/logo.png',
      "alt": ""
    }
  })]), _c('a-col', {
    attrs: {
      "xs": 0,
      "sm": 12,
      "md": 20,
      "lg": 20,
      "xl": 20
    }
  }, [_c('a-row', {
    staticClass: "footer-menu"
  }, _vm._l(_vm.menus, function (m1, i) {
    return _c('a-col', {
      key: i,
      attrs: {
        "xs": 6,
        "sm": 6,
        "md": 4,
        "lg": 3,
        "xl": 3
      }
    }, [_c('h3', [_c('a', {
      attrs: {
        "href": m1.url
      }
    }, [_vm._v(_vm._s(m1.title))])]), _vm._l(m1.children, function (m2, j) {
      return _c('h4', {
        key: j
      }, [_c('a', {
        attrs: {
          "href": m2.url
        }
      }, [_vm._v(_vm._s(m2.title))])]);
    })], 2);
  }), 1)], 1)], 1), _vm._m(0)], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "footer2"
  }, [_c('div', {
    staticClass: "logoList",
    staticStyle: {
      "font-family": "Arial, 'Microsoft Yahei', 'Helvetica Neue', Helvetica, sans-serif",
      "font-size": "16px"
    },
    attrs: {
      "data-v-efc58504": ""
    }
  }, [_c('div', {
    staticClass: "logoList",
    staticStyle: {
      "text-align": "start"
    },
    attrs: {
      "data-v-efc58504": ""
    }
  }, [_c('ul', {
    staticClass: "cyscc_footer_main",
    staticStyle: {
      "margin": "0px auto",
      "padding": "0px",
      "list-style": "none",
      "overflow": "hidden",
      "position": "relative",
      "line-height": "90px",
      "text-align": "center"
    },
    attrs: {
      "data-v-efc58504": ""
    }
  }, [_c('li', {
    staticStyle: {
      "cursor": "auto",
      "display": "inline-block",
      "margin": "0px 30px"
    },
    attrs: {
      "data-v-efc58504": ""
    }
  }, [_c('img', {
    staticClass: "cyscclogo cyscclogo",
    staticStyle: {
      "border": "0px",
      "vertical-align": "middle",
      "height": "52px"
    },
    attrs: {
      "src": "https://cyscc.org/img/%E9%A1%B5%E5%BA%95logo2@2x.png",
      "data-v-efc58504": ""
    }
  })]), _c('li', {
    staticStyle: {
      "cursor": "pointer",
      "display": "inline-block",
      "margin": "0px 30px"
    },
    attrs: {
      "data-v-efc58504": ""
    }
  }, [_c('a', {
    staticStyle: {
      "outline": "none 0px",
      "border": "none",
      "text-decoration-line": "none",
      "color": "#25a4bb"
    },
    attrs: {
      "href": "http://www.cacsi.org.cn/",
      "target": "_blank",
      "rel": "noopener",
      "data-v-efc58504": ""
    }
  }, [_c('img', {
    staticClass: "cyscclogo cyscclogo",
    staticStyle: {
      "border": "0px",
      "vertical-align": "middle",
      "height": "52px"
    },
    attrs: {
      "src": "https://cyscc.org/img/logo-cacsi.png",
      "data-v-efc58504": ""
    }
  })])]), _c('li', {
    staticStyle: {
      "cursor": "pointer",
      "display": "inline-block",
      "margin": "0px 30px"
    },
    attrs: {
      "data-v-efc58504": ""
    }
  }, [_c('a', {
    staticStyle: {
      "outline": "none 0px",
      "border": "none",
      "text-decoration-line": "none",
      "color": "#25a4bb"
    },
    attrs: {
      "href": "https://www.kepuchina.cn/",
      "target": "_blank",
      "rel": "noopener",
      "data-v-efc58504": ""
    }
  }, [_c('img', {
    staticClass: "cyscclogo2 cyscclogo",
    staticStyle: {
      "border": "0px",
      "vertical-align": "middle",
      "height": "52px"
    },
    attrs: {
      "src": "https://cyscc.org/img/%E9%A1%B5%E5%BA%95logo4@2x.png",
      "data-v-efc58504": ""
    }
  })])])])])])]);
}];
export { render, staticRenderFns };